import styled from 'styled-components'
import healthSpaceImage from 'static/svg/telavita-health-space-card/health-space-image.svg'

export const HealthSpaceImage = styled.div`
  height: 135px;
  width: calc(100% + 40px);
  margin: 14px -20px 10px;
  background-image: url(${healthSpaceImage});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`

export const WrapperContent = styled.div`
  > p {
    margin-bottom: 16px;
    line-height: 20px;
  }
`

export const Link = styled.a`
  > button {
    height: fit-content;
    padding: 0;
  }
`